import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import { VesselMachineModelsModel } from "@/types/machineModel";
import machineModelsClient from "Clients/machine-models-client";

@Module({ namespaced: true, name: "MachineModels" })
class MachineModels extends VuexModule {
  private _machineModelsExpired = true;
  private _vesselMachineModels: VesselMachineModelsModel[] = [];
  private _isLoading = false;

  @Mutation
  public SET_MACHINE_MODELS(models: VesselMachineModelsModel[]): void {
    this._machineModelsExpired = false;
    this._vesselMachineModels = models;
  }

  @Mutation
  public SET_LOADING(isLoading: boolean): void {
    this._isLoading = isLoading;
  }

  @Mutation
  public EXPIRE_DATA(): void {
    this._machineModelsExpired = true;
  }

  @Action({ rawError: true })
  public async fetchCompanyMachineModels(companyId: number): Promise<VesselMachineModelsModel[]> {
    this.context.commit("SET_LOADING", true);
    try {
      const data = await machineModelsClient.getCompanyDataQualityMachineModels(companyId);
      this.context.commit("SET_MACHINE_MODELS", data);
      return data;
    } catch (error) {
      throw error;
    } finally {
      this.context.commit("SET_LOADING", false);
    }
  }

  get vesselMachineModels(): VesselMachineModelsModel[] {
    return this._vesselMachineModels;
  }

  get isLoading(): boolean {
    return this._isLoading;
  }

  get machineModelsCount(): number {
    return this._vesselMachineModels.length;
  }
}

export default MachineModels;
